module.exports = __webpack_public_path__ + "static/media/whatsapp-color.e2be0756.svg";